import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=3796a08f&scoped=true"
import script from "./tabs.ts?vue&type=script&lang=ts&external"
export * from "./tabs.ts?vue&type=script&lang=ts&external"
import style0 from "./tabs.vue?vue&type=style&index=0&id=3796a08f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3796a08f",
  null
  
)

export default component.exports